import React from 'react'
import PropTypes from 'prop-types'

import classNames from 'classnames'

import { cloudinaryImageUrl } from '@scentregroup/ui/tools/cloudinary/image'
import style from './index.module.scss'

function getCloudinaryImageUrl(image) {
  const src = image.replace(/^https:/, '')
  return cloudinaryImageUrl({
    src,
    bgSize: 'contain',
    numberOfItems: 2,
    ratio: 'square',
  })
}

class ProductImage extends React.Component {
  constructor(props) {
    super(props)
    this.state = { loading: true }
  }

  componentDidMount() {
    if (this.imageElm) {
      if (this.imageElm.complete) {
        this.imageLoaded()
      } else {
        this.imageElm.addEventListener('load', this.imageLoaded)
      }
    }
  }

  imageRef = elm => {
    this.imageElm = elm
  }

  imageLoaded = () => {
    this.setState({ loading: false })
  }

  render() {
    const { tag, className, loadingClassName, alt, src } = this.props

    return (
      <div
        className={classNames(style.productImage, className, {
          [loadingClassName]: loadingClassName && this.state.loading,
        })}
      >
        <img ref={this.imageRef} alt={alt} src={getCloudinaryImageUrl(src)} />
        {tag !== undefined && tag.trim() !== '' ? (
          <div className={style.tag}>{tag}</div>
        ) : null}
      </div>
    )
  }
}

ProductImage.propTypes = {
  src: PropTypes.string.isRequired,
  tag: PropTypes.string,
  className: PropTypes.string,
  loadingClassName: PropTypes.string,
  alt: PropTypes.string.isRequired,
}
export default ProductImage
